module.exports = __webpack_public_path__ + "static/media/tree1.408b16dc.png";